import React from 'react';
import SocialMediaSelector from './SocialMediaSelector';

const InstagramMediaSelector = (props) => {
	return (
		<SocialMediaSelector
			{...props}
			type='instagram'
			/*fake_user_token={{
				id:6567176246660806,
				username:'marcmateos', access_token:'IGQWRPUlZA0ZA0J5emtNTHdLbHFLZA0xHNUVqczd6dEN4RnZA1YWFOeGlkQXROc0dISU9Ub2JoejB1M0dtWWZALanVpNlpCWW92UXY2dG95M2s3NmFnYXI5SG1vWkJNMVdfdHQ4UWtsNno3ZA0N3VlQ0ZADU2N0d3Qld2VWJEZAlRERFc1MnlvZAwZDZD',
			}}*/
		/>
	)
}

export default InstagramMediaSelector;